import { createAsyncThunk } from "@reduxjs/toolkit";
//import axios from "axios";
//import { API_URL } from "src/utils/apiConfig";
import { unitsError, unitsSuccess } from "./reducer";
import { userId } from "src/helpers/user_id";
import { apiClient } from '../../helpers/api_helper';

export const getUnits = createAsyncThunk("unity/getUnits", async () => {
  try {
    const response = await apiClient.get(`/unity/unities/`);
    return response;
  } catch (error) {
    return error;
  }
});

export const addUnit = createAsyncThunk("unity/addUnit", async (unit: any, { dispatch }) => {
    try {
      const response = await apiClient.post(`/unity/unities/`,{
          name: unit.name,
          tipo: unit.tipo,
          parent: unit.parent,
          create_user: userId,
          update_user: userId,
        });
      dispatch(unitsSuccess(response));
      return response;
    } catch (error) {
      dispatch(unitsError(error));
      return error;
    }
  }
);

export const updateUnit = createAsyncThunk("unity/updateUnit", async (unit: any) => {
    try {
      const response = await apiClient.put(`/unity/unities/${unit.id}/`,{
          name: unit.name,
          tipo: unit.type,
          parent: unit.parent,
          create_user: userId,
          update_user: userId,
        });
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteUnit = createAsyncThunk("unity/deleteUnit",async (unitId: any) => {
    try {
      const response = await apiClient.delete(`/unity/unities/${unitId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);
